export const toggleButtonConfig = () => {
  return {
    root: {
      padding: '4px',

      content: {
        padding: '4px 8px'
      },

      borderRadius: '{borderRadius.sm}',
      color: 'var(--primary-950)',
      background: 'var(--primary-50)',
      borderColor: 'transparent',
      checkedColor: 'var(--primary-950)',
      hoverBackground: 'var(--primary-400)',
      checkedBackground: 'var(--primary-50)',
      checkedBorderColor: 'transparent',
      contentCheckedBackground: 'var(--primary-500)',
      disabledBackground: 'var(--card-bg-01)'
    }
  }
}

export const toggleButtonPt = () => {
  return {
    label: {
      class: 'font-14-m'
    }
  }
}
